import React from "react";
import PropTypes from "prop-types";
import DeviceManagementView from "../DeviceManagementView";
import PatronManagementView from "../PatronManagementView";
import "./ViewContainer.css";

/**
 * ViewContainer - Routes between device and patron management views
 * 
 * Handles view switching logic and passes appropriate props to each view component
 */
const ViewContainer = ({
  currentView,
  deviceViewProps,
  patronViewProps,
}) => {
  return currentView === "patrons" ? (
    <PatronManagementView {...patronViewProps} />
  ) : (
    <DeviceManagementView {...deviceViewProps} />
  );
};

ViewContainer.propTypes = {
  currentView: PropTypes.oneOf(["devices", "patrons"]).isRequired,
  deviceViewProps: PropTypes.object.isRequired,
  patronViewProps: PropTypes.object.isRequired,
};

export default ViewContainer;
